import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Container from '@material-ui/core/Container';
import Typography from '../Typography/Typography';
import Button from '@material-ui/core/Button';
import { Link } from 'gatsby';

import GetQuoteImg from '../../assets/img/bg-clean1.jpeg';

const styles = (theme) => ({
  root: {
    marginTop: theme.spacing(8),
    display: 'flex',
    '@media (max-width: 992px)': {
      marginTop: theme.spacing(5),
    },
  },
  cardWrapper: {
    zIndex: 1,
  },
  card: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'white',
    padding: theme.spacing(8, 3),
    boxShadow:
      '0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
    '@media (max-width: 992px)': {
      boxShadow: 'none',
      padding: '0px',
    },
  },
  cardContent: {
    maxWidth: 400,
  },
  textField: {
    width: '100%',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  imagesWrapper: {
    position: 'relative',
  },
  image: {
    position: 'absolute',
    top: -28,
    left: -28,
    right: 0,
    bottom: 0,
    width: '100%',
    maxWidth: 600,
  },
});

function GetQuote(props) {
  const { classes } = props;

  return (
    <Container maxWidth='md'>
      <Grid container>
        <Grid item xs={12} md={6} className={classes.cardWrapper}>
          <div className={classes.card}>
            <div className={classes.cardContent}>
              <Typography
                variant='h2'
                component='h2'
                gutterBottom
                align='center'
              >
                Catered Cleaning
              </Typography>
              <Typography
                variant='h5'
                component='h5'
                gutterBottom
                align='center'
              >
                We care about our customers, that's why we'll cater to your
                needs.
              </Typography>
              <Link to='/booking/' className={classes.customLink}>
                <Button color='secondary' variant='contained' fullWidth>
                  Book Now
                </Button>
              </Link>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={6} className={classes.imagesWrapper}>
          <Hidden smDown>
            <div className={classes.imageDots} />
            <img
              src={GetQuoteImg}
              alt='call to action'
              className={classes.image}
            />
          </Hidden>
        </Grid>
      </Grid>
    </Container>
  );
}

export default withStyles(styles)(GetQuote);
